<template>
    <div class="mb-3 row col-12 py-3 px-3">
        <div
            v-if="parentKey && !dataSet?.key_formatted && parentKey !== 'editable'"
            class="mb-3 border-bottom col-12 row py-2"
        >
            <strong>{{ parentKey }}</strong>
        </div>

        <template v-for="(value, key) in dataSet">
            <template v-if="typeof value === 'object' && isNotPresent(value?.key_formatted)">
                <div class="col-12 px-4">
                    <ViewArrayElement :data-set="value" :parent-key="key"></ViewArrayElement>
                </div>
            </template>
            <template v-else>
                <div class="border-bottom col-12 px-2">
                    <ViewJsonSingleElement :data-set="value" :parent-key="key" :col9="true"></ViewJsonSingleElement>
                </div>
            </template>
        </template>
    </div>
</template>
<script>
import ViewJsonSingleElement from './ViewJsonSingleElement.vue';
import { testIsNull, testIsUndefined } from '../../../../../../../../lib/test-and-assert/test-base';

export default {
    name: 'ViewArrayElement',
    components: { ViewJsonSingleElement },
    props: ['dataSet', 'parentKey', 'col9'],
    data() {
        return {
            status: 'No Status',
            showOutput: false,
        };
    },
    mounted: function () {
        this.showOutput = true;
    },
    methods: {
        isNotPresent(value) {
            return testIsNull(value) || testIsUndefined(value);
        },
    },
};
</script>
<style scoped>
.scroll-height {
    height: calc(100vh - 80px);
}
.grayBackground {
    background-color: #d9dadb;
}
</style>
